import { useState } from "react";
import {
  useProgram, ProgramGate, ProgramLoading, NeedAuth, ProgramShell, useProgress, ProgressBar,
  CompleteButton, Block, Paragraphs, Mantra, AccordionItem,
} from "@/pages/programs/_gate";

const muted = "text-sm sm:text-base text-muted-foreground leading-relaxed";

export default function ThirtyDayShift() {
  const { loading, data, locked, needsAuth } = useProgram("/programs/thirty-day-shift");
  const { done, toggle, isDone } = useProgress("thirty_day_shift");
  const [openDay, setOpenDay] = useState(null);

  if (needsAuth) return <NeedAuth />;
  if (loading) return <ProgramLoading />;
  if (locked) return <ProgramGate productKey="thirty_day_shift" priceLabel="The 30-Day Shift · $88" purchaseCta="Unlock for $88" />;
  if (!data) return <ProgramLoading />;

  const firstOpen = data.days.find((d) => !isDone(d.day))?.day ?? -1;
  const current = openDay ?? firstOpen;

  const complete = (day) => {
    const wasDone = isDone(day);
    toggle(day);
    if (!wasDone) setOpenDay(day < data.days.length ? day + 1 : -1);
  };

  return (
    <ProgramShell eyebrow="Program · 30 days" title={data.title}>
      <p className="text-muted-foreground max-w-2xl mb-8 leading-relaxed">
        One day at a time. One shift at a time. This is not a course to finish — it's a rhythm to keep. Each day has a teaching, one practice, one journal prompt and a mantra. Return every day. The compound is the point.
      </p>
      <ProgressBar done={done.length} total={data.days.length} label="days" />
      <div className="space-y-3">
        {data.days.map((d) => (
          <AccordionItem
            key={d.day}
            id={`day-${d.day}`}
            number={String(d.day).padStart(2, "0")}
            eyebrow={`Day ${d.day} of 30`}
            title={d.title}
            open={current === d.day}
            done={isDone(d.day)}
            onToggle={() => setOpenDay(current === d.day ? -1 : d.day)}
          >
            <Block label="Teaching"><Paragraphs text={d.body} /></Block>
            <Block label="Today's practice" accent><p className={muted}>{d.practice}</p></Block>
            <Block label="Journal prompt"><p className="font-serif italic text-base sm:text-lg">{d.prompt}</p></Block>
            <Block label="Mantra"><Mantra text={d.mantra} /></Block>
            <CompleteButton done={isDone(d.day)} onClick={() => complete(d.day)} testId={`day-${d.day}-complete`} />
          </AccordionItem>
        ))}
      </div>
    </ProgramShell>
  );
}
